import { interviews } from "../../assets/text/interview";

const MainMobileArabicScreen = ({
  handleImageLink,
  handleMobileNavigation,
}) => {
  const data = interviews;
  return (
    <div className="main-responsive-arabic">
      <div className="main-responsive-arabic-instructions">
        يرجى استخدام الاصدار المكتبي للموقع الإلكتروني للحصول على التجربة
        الكاملة للأداة التي قمنا بإعدادها{" "}
      </div>
      <div className="main-responsive-arabic-video">
        <span className="main-responsive-arabic-video-text">
          {" "}
          عـــرض سريــــع
        </span>
        <div className="main-responsive-arabic-video-div">
          <video style={{ width: "100%" }} controls>
            <source src="/vid/bilingualwebsite-tutorial.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
      <div className="main-responsive-arabic-articles">
        <span className="main-responsive-arabic-articles-more">للمزيد </span>
        {data.map((article) => (
          <div
            key={article.content.arabic.date}
            className="main-responsive-arabic-articles-article"
          >
            <div className="main-responsive-arabic-articles-article-text">
              <div
                className="main-responsive-arabic-articles-article-text-title"
                onClick={() => {
                  handleImageLink(true, article);
                  handleMobileNavigation("interview");
                }}
              >
                {article.content.arabic.title}
              </div>
              <div className="main-responsive-arabic-articles-article-text-date">
                {`${article.content.arabic.date}  /`}
                <span style={{ textDecoration: "none" }}>
                  &nbsp;{article.content.arabic.category}
                </span>
              </div>
            </div>
            <div style={{ width: "35%" }}>
              <img
                className="main-responsive-arabic-articles-article-image"
                src={`images/${article.imageSquare}`}
                alt="Article"
              ></img>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainMobileArabicScreen;
